import { render, staticRenderFns } from "./AssignCustomerTab.vue?vue&type=template&id=59057dc8"
import script from "./AssignCustomerTab.vue?vue&type=script&lang=js"
export * from "./AssignCustomerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports